<template>
    <span>
        <slot><span class="fa fa-question-circle text-gray"></span></slot>
    </span>
</template>

<script>
import PopperTooltip from 'tooltip.js';
export default {
    props: [
        'title'
    ],
    mounted() {
        new PopperTooltip(this.$el, {
            placement: 'top',
            title: this.title
        });
    }
}
</script>

<style>
    .tooltip-inner {
        position: relative;
        max-width: 200px;
        font-size: 13px;
        padding: .2em .5em;
        z-index: 100000;
        border-radius: 3px;
        background-color: #000;
        color: #fff;
        text-align: center;
    }
</style>
